import { getLocalProtocol } from 'src/presentation/utils/get-local-protocol'

export const settings = {
  siteName: process.env.REACT_APP_TITLE,
  API_URL: process.env.REACT_APP_API_URL,
  TOKEN: process.env.REACT_APP_TOKEN || 'TOKEN',
  DOMAIN: process.env.REACT_APP_DOMAIN || 'localhost',
  DOMAIN_PROTOCOL: getLocalProtocol() + process.env.REACT_APP_DOMAIN || 'localhost',
  MSAL_CLIENT_ID: process.env.REACT_APP_MSAL_CLIENT_ID,
  MSAL_TENANT_ID: process.env.REACT_APP_MSAL_TENANT_ID,
  perPage: 15,
  perPageBu: 5,
  perPageOptions: [15, 30, 50, 100],
  perPageBuOptions: [5, 10, 20, 30],
  pagination: {
    pageRangeDisplayed: 3,
    hideDisabled: true,
    hideFirstLastPages: false,
    hideNavigation: true,
    linkClassFirst: 'arrow first',
    linkClassPrev: 'arrow prev',
    linkClassNext: 'arrow next',
    linkClassLast: 'arrow last',
  },
}
